import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '../../theme';

const items = [
  { n: '10,247', l: 'users signed up', sub: 'across 4 platforms' },
  { n: '18,431', l: 'tags filed', sub: '~1.8 per user' },
  { n: '1,312', l: 'reunions to date', sub: '≈ 2 per day' },
  { n: '0', l: 'records ever sold', sub: 'and never will be' },
];

const targets = items.map(it => parseInt(it.n.replace(/,/g, ''), 10));

function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

export default function StatsStrip() {
  const { p, d, fonts } = useTheme();
  const ref = useRef(null);
  const animated = useRef(false);
  const [counts, setCounts] = useState(targets.map(() => 0));

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !animated.current) {
        animated.current = true;
        const duration = 2000;
        const start = performance.now();
        function tick(now) {
          const t = Math.min((now - start) / duration, 1);
          const e = easeOutCubic(t);
          setCounts(targets.map(target => target === 0 ? 0 : Math.round(target * e)));
          if (t < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} style={{
      borderBottom: `1px solid ${p.border}`,
      padding: `${d.gap * 1.4}px ${d.pad}px`,
    }}>
      <div style={{ maxWidth: 1180, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 0 }}>
        {items.map((it, i) => (
          <div key={i} style={{
            padding: `8px ${d.gap}px`,
            borderLeft: i > 0 ? `1px solid ${p.border}` : 'none',
          }}>
            <div style={{
              fontFamily: fonts.mono, fontSize: 11, color: p.textDim,
              letterSpacing: '.12em', textTransform: 'uppercase', marginBottom: 8,
            }}>
              {String(i + 1).padStart(2, '0')} · {it.l}
            </div>
            <div style={{
              fontFamily: fonts.serif, fontSize: 42, fontWeight: 400,
              color: p.textHi, letterSpacing: '-.02em', lineHeight: 1,
            }}>
              {counts[i].toLocaleString()}
            </div>
            <div style={{ fontFamily: fonts.mono, fontSize: 11.5, color: p.textFaint, marginTop: 6 }}>
              {it.sub}
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @media (max-width: 768px) {
          section > div { grid-template-columns: repeat(2, 1fr) !important; }
        }
      `}</style>
    </section>
  );
}
